import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { isNil } from 'lodash'

const Currency = ({
  amount,
  renderEmpty,
  noSymbol,
  noDecimal,
  noComma,
}) => {
  const value = useMemo(() => {
    if (isNil(amount) || isNaN(amount)) return renderEmpty

    const number = (+amount).toLocaleString('en-US', {
      style: noSymbol ? undefined : 'currency',
      currency: 'USD',
      minimumFractionDigits: amount % 1 === 0 && noDecimal === 'conditional' ? 0 : noDecimal === true ? 0 : 2,
      maximumFractionDigits: amount % 1 === 0 && noDecimal === 'conditional' ? 0 : noDecimal === true ? 0 : 2,
    })

    return noComma ? number.replaceAll(',', '') : number
  }, [
    amount,
    renderEmpty,
    noSymbol,
    noDecimal,
    noComma,
  ])
  
  return value
}

Currency.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  noDecimal: PropTypes.oneOf([true, false, 'conditional']),
  noSymbol: PropTypes.bool,
  noComma: PropTypes.bool,
  renderEmpty: PropTypes.node,
}

Currency.defaultProps = {
  renderEmpty: <div />,
}

export default Currency
